import React from 'react'
import ChipFilterInput, {createFilterChip, generateVariableFilterChip} from '../components/ChipFilterInput'
import ChipInput from 'material-ui-chip-input'
import Avatar from 'material-ui/Avatar'
import { green800, green300, red300, red800, orange300, orange800, grey300, grey800 } from 'material-ui/styles/colors'
import {connect} from "react-redux";
import {Keys} from "../../model/constants/keys";
import * as Immutable from "immutable";
import UpdateInfo from '../components/UpdatedInfo'
import {loadWorkSessionItems} from "../../model/action-creators/item-actions";

function getGroupChip(name, short) {
    return createFilterChip('GROUP', 'Group: '+name, short, short, green300, green800);
}

const variableFilterChips = [
    generateVariableFilterChip(t => "Name contains: "+t,
    'name', t => '...'+t+'...', grey300, grey800)
]
const originalDataSource = [
    getGroupChip('Night Shift', 'NS'),
    getGroupChip('Day Shift', 'DS'),
    getGroupChip('Beta', 'ß'),
    createFilterChip('W', 'In Work Session', 'W', 'W', red300, red800),
    createFilterChip('A', 'Active', 'Active', 'Active', orange300, orange800),
];

class TestPage extends React.Component {

    constructor(props) {
        super(props);
        this.handleFilters= this.handleFilters.bind(this);
    }

    handleFilters(filters) {
        filters.forEach(console.dir)
    }
    render() {
        return (

            <ChipFilterInput
                applyFilter={this.handleFilters} filterChips={originalDataSource} filterChipsFactories={variableFilterChips}/>
        )
    }
}
const mapSateToProps = (state) => {
    return {
        itemsState: state.itemsState,
        currentWorkSession: state.currentWorkSessionState.get(Keys.StoreSliceData.CURRENT_WORK_SESSION,Immutable.Map()),

    }
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch:dispatch,
    }
};

export default connect(mapSateToProps, mapDispatchToProps)(TestPage);



/*
 <ChipInput
 dataSource={[{ label: 'Chip 1', id: 'one' }, { label: 'Chip 2', id: 'two' }]}
 dataSourceConfig={{ text: 'label', value: 'id' }}
 defaultValue={[{ label: 'Chip 1', id: 'one' }]}
 />

 */


// WEBPACK FOOTER //
// ./src/ui/pages/TestPage.js